export class CountBySubCategoriesDetails{
    date:Date;
    subCategoryName:string;
    tdyActualRevenue:string;
    uom:string;
}